(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/jackpot-header/assets/javascripts/helpers/handlebarhelpers.js') >= 0) return;  svs.modules.push('/components/tur/jackpot-header/assets/javascripts/helpers/handlebarhelpers.js'); 
'use strict';

if (svs.isServer) {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}
function registerHelpers(hbs) {
  hbs.registerHelper('jackpotCalendarTime', date => {
    if (date !== null && date !== undefined) {
      let formattedDate = svs.utils.date.getLocalizedWeekday(date).toLowerCase();
      formattedDate += " ".concat(svs.utils.date.SimpleTime(date));
      return formattedDate;
    }
    return false;
  });
}
 })(window);